export class AuthenticationResult {
    
    accessTokenType:string;           
    expiresIn:number;
    expiresOn :  Date;
    idToken:string;     
    userInfo: UserInfo;
    accessToken :  string;
    refreshToken :  string;
    isMultipleResourceRefreshToken :  boolean;  
 
} 
export class UserInfo { 
    
    uniqueId:string;
    displayableId:string;
    givenName:string;
    familyName:string;
    identityProvider:string;
    passwordChangeUrl :  string;
    passwordExpiresOn :  Date;
    
} 

export class LoggedInInfo {
    userName: string;
    authorityCode: string;
    emailId: string;
    displayableId: string;
    isAuthenticated: boolean;
    signout: string;
    expiresOn: Date;
    accessToken:string;
    homeAccountId: string;
  }
  export class LoggedOutInfo {
    userName: string;
    authorityCode: string;
    sessionState: string;
    emailId: string;
    displayableId: string;
    isAuthenticated: boolean;
    signout: string;
    expiresOn: Date;
    accessToken:string;
    refreshToken:string;
  
  }
  export class UsersList {
    objectId: string;
    objectType: string;
    accountEnabled: string;
    city: string;
    country: string;
    department: string;
    dirSyncEnabled: string;
    displayName: string;
    facsimileTelephoneNumber: string;
    givenName: string;
    jobTitle: string;
    lastDirSyncTime: string;
    mail: string;
    mailNickname: string;
    mobile: string;
    password: string;
    passwordPolicies: string;
    physicalDeliveryOfficeName: string;
    postalCode: string;
    preferredLanguage: string;
    state: string;
    streetAddress: string;
    surname: string;
    telephoneNumber: string;
    usageLocation: string;
    userPrincipalName: string;
    isDeleted: boolean; // this will move to dto
    firstName: string;
    lastName: string;
    error:number;
  }